import React from 'react';
import ReactDOM from 'react-dom';
import App from 'App';
import i18n from 'i18n';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import registerServiceWorker from 'registerServiceWorker';
import rootStore from 'store/rootStore';
import { Helmet } from 'react-helmet';
import { configure } from 'mobx';

// Mobx configuration
configure({ enforceActions: 'always' });

ReactDOM.render((
    <Provider store={rootStore}>
        <I18nextProvider i18n={i18n}>
            <Helmet titleTemplate="%s | Budgetti" />
            <BrowserRouter>
                <App />
            </BrowserRouter>
            <div id="modal-root" />
        </I18nextProvider>
    </Provider>
), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js